/**
 * Feriados nacionais brasileiros, calculados por ano.
 * Datas móveis derivam da Páscoa (algoritmo de Meeus/Butcher).
 * Feriados estaduais e municipais não entram aqui de propósito: o time é
 * distribuído e o que pesa no plantão é o feriado que para o país.
 */

function domingoDePascoa(ano) {
  const a = ano % 19;
  const b = Math.floor(ano / 100);
  const c = ano % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const mes = Math.floor((h + l - 7 * m + 114) / 31);
  const dia = ((h + l - 7 * m + 114) % 31) + 1;
  return Date.UTC(ano, mes - 1, dia);
}

const DIA = 86400000;

function chave(ms) {
  return new Date(ms).toISOString().slice(0, 10);
}

const cache = new Map();

/** Mapa { "AAAA-MM-DD": "Nome do feriado" } para o ano informado. */
export function feriadosDoAno(ano) {
  if (cache.has(ano)) return cache.get(ano);

  const pascoa = domingoDePascoa(ano);
  const feriados = {
    [chave(Date.UTC(ano, 0, 1))]: "Confraternização Universal",
    [chave(pascoa - 48 * DIA)]: "Carnaval",
    [chave(pascoa - 47 * DIA)]: "Carnaval",
    [chave(pascoa - 2 * DIA)]: "Sexta-feira Santa",
    [chave(Date.UTC(ano, 3, 21))]: "Tiradentes",
    [chave(Date.UTC(ano, 4, 1))]: "Dia do Trabalho",
    [chave(pascoa + 60 * DIA)]: "Corpus Christi",
    [chave(Date.UTC(ano, 8, 7))]: "Independência",
    [chave(Date.UTC(ano, 9, 12))]: "Nossa Senhora Aparecida",
    [chave(Date.UTC(ano, 10, 2))]: "Finados",
    [chave(Date.UTC(ano, 10, 15))]: "Proclamação da República",
    [chave(Date.UTC(ano, 11, 25))]: "Natal",
  };

  // Consciência Negra é feriado nacional a partir de 2024 (Lei 14.759/2023).
  if (ano >= 2024) {
    feriados[chave(Date.UTC(ano, 10, 20))] = "Consciência Negra";
  }

  cache.set(ano, feriados);
  return feriados;
}

/** Nome do feriado na data, ou null. */
export function feriadoEm(chaveData) {
  const ano = Number(chaveData.slice(0, 4));
  return feriadosDoAno(ano)[chaveData] || null;
}
